import * as React from 'react';
import {FunctionComponent} from 'react';
import {Loader} from '../../Components/Utils/Loader';

interface OwnProps {
    title: string;
}

export const Preview: FunctionComponent<OwnProps> = ({title}) => {
    return (
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <h1>{title}</h1>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <Loader />
                </div>
            </div>
        </div>
    );
};
